export default __webpack_public_path__ + "static/media/front_loader.f476f656.gif";